module.exports = __webpack_public_path__ + "img/job-Ready-new.c588b6a8.svg";